/**
 * Chat-related constants
 *
 * These enums provide runtime-accessible values for chat message types
 * and related functionality.
 */

/**
 * Chat message type enum
 * Use these instead of string literals like 'user' or 'system'
 */
export enum ChatMessageTypeEnum {
  // User messages
  USER = 'user',
  ASSISTANT = 'assistant',

  // NPC messages
  TAVIAN = 'tavian',
  ALDRIC = 'aldric',
  KIRA = 'kira',
  GROLT = 'grolt',
  NPC = 'npc',
  DM = 'dm',

  // System messages
  SYSTEM = 'system',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',

  // Party events
  PARTY_JOIN = 'party-join',
  PARTY_LEAVE = 'party-leave',

  // Game events
  ROLL = 'roll',
}

/**
 * Active NPC enum (lobby NPCs that can be talked to)
 */
export enum ActiveNPCEnum {
  TAVIAN = 'tavian',
  ALDRIC = 'aldric',
  KIRA = 'kira',
  GROLT = 'grolt',
}

/**
 * Lobby chat message type enum
 */
export enum LobbyChatTypeEnum {
  CHAT = 'chat',
  SYSTEM = 'system',
  EMOTE = 'emote',
  SUCCESS = 'success',
}

/**
 * NPC intent type enum (for NPC decision making)
 */
export enum NPCIntentTypeEnum {
  SPEAK = 'speak',
  ACCEPT_PARTY_INVITE = 'accept_party_invite',
  DECLINE_PARTY_INVITE = 'decline_party_invite',
  QUERY_MY_CHARACTER = 'query_my_character',
  OBSERVE_CHARACTER = 'observe_character',
  DECIDE_RESPONSE = 'decide_response',
}

/**
 * NPC personality type enum (for voting behavior)
 */
export enum NPCPersonalityTypeEnum {
  BOLD = 'bold',
  CAUTIOUS = 'cautious',
  SUSPICIOUS = 'suspicious',
  AGREEABLE = 'agreeable',
}
